import {WEEKDAYS_LONG, WEEKDAYS_SHORTER, MONTHS} from './timeLocaleData';

const FIRST_DAY = {
  'en': 1,
  'sv': 1,
};

export default {
  formatDay: (d, locale='en') => `${WEEKDAYS_LONG[locale][d.getDay()]}, ${d.getDate()} ${MONTHS[locale][d.getMonth()]} ${d.getFullYear()}`,
  formatMonthTitle: (d, locale='en') => `${MONTHS[locale][d.getMonth()]} ${d.getFullYear()}`,
  formatWeekdayShort: (i, locale='en') => WEEKDAYS_SHORTER[locale][i],
  formatWeekdayLong: (i, locale='en') => WEEKDAYS_LONG[locale][i],
  getFirstDayOfWeek: (locale='en') => FIRST_DAY[locale]
};



// WEBPACK FOOTER //
// ./src/i18n/reactDayPickerLocaleData.js